import './Empty.css'

const Empty = (empty) => {
    return (
        <div id="empty">
            This should not be visible. 
            If you are reading this the website is at least mildly broken. 
            Please let me know at: esnow272@gmail.com.
        </div>
    );
};

export default Empty;